Ext.define('SA.view.newproject.LocationsWindow', {
    alias: 'widget.new-project-locations-window',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-new-project-window',
    floating: true,
    height: 495,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',
    width: 480,

    items: [
        {
            xtype: 'simple-container',

            items: [
                {
                    xtype: 'close-button',
                    closeAction: 'onCloseClick'
                }, {
                    xtype: 'component',
                    cls: 'sa-new-project-locations-window-heading',
                    html: '<div class="sa-new-project-locations-window-title">New Project</div>'
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-new-project-locations-window-country-row',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-new-project-locations-window-country-instruction',
                    html: 'Select a country for this project:'
                }, {
                    xtype: 'combo-button',
                    itemId: 'countryCombo',
                    textField: 'name',
                    ui: 'underline',
                    valueField: 'code',

                    listeners: {
                        beforerender(cmp) {
                            cmp.setValue(SA.Institution.getLocale());
                        }
                    },

                    buildItems() {
                        return SA.Institution.getCountries().map(country => {
                            var code = country.getCode(),
                                name = country.getName();

                            return {code, name};
                        });
                    },

                    selectHandler(value) {
                        this.up('new-project-locations-window').onCountrySelected(value);
                    }
                }
            ]
        }, {
            xtype: 'component',
            cls: 'sa-new-project-locations-window-search-instruction',
            html: 'Search for one or more locations that you would like to analyze:'
        }, {
            margin: '12 32 10',
            xtype: 'location-search-field',

            xhooks: {
                beforeRender() {
                    this.getRecentList().checkMarkTooltip = 'Added to project';

                    this.callParent();
                }
            }
        }, {
            xtype: 'selected-locations-list',
            flex: 1,
            margin: '0 32'
        }, {
            xtype: 'simple-container',
            cls: 'sa-new-project-window-footer',

            items: [{
                xtype: 'sa-button',
                autoEl: 'button',
                text: 'Next',
                ui: 'primary',
                width: 118,

                handler() {
                    this.up('new-project-locations-window').onNextClick();
                }
            }]
        }
    ],

    initComponent() {
        this.callParent();

        this.searchField = this.down('location-search-field');
        this.locationsList = this.down('selected-locations-list');

        this.searchField.on('select', this.onSelectLocation, this);
        this.locationsList.on('change:locations', this.onChangeLocations, this);

        SA.view.SearchFieldInertMaskController.create({field: this.searchField});
    },

    addLocation(locationSeries) {
        this.locationsList.addLocation(locationSeries);
    },

    beforeRender() {
        if (SA.Institution.getCountries().length > 1) {
            this.addCls('sa-new-project-locations-window-multi-country');
        }
    },

    afterRender() {
        this.callParent();
        this.el.dom.setAttribute('tabindex', '0');
        this.el.dom.focus();
        this.el.dom.removeAttribute('tabindex');
    },

    getSelectedCountry() {
        return this.down('#countryCombo').getValue();
    },

    onChangeLocations() {
        var searchField = this.searchField,
            locationsList = this.locationsList;

        searchField.setSelected(locationsList.getLocations());
    },

    onCloseClick() {
        this.fireEvent('click:close');
    },

    onCountrySelected(countryCode) {
        var country = SA.Institution.getCountry(countryCode),
            censusRelease = country.getLatestCensusRelease(),
            geographicRelease = country.getLatestGeographicRelease(),
            units = SA.data.GeographicUnits.findIds({
                censusRelease,
                country: countryCode,
                includeCountry: true,
                units: SA.data.GeographicUnits.getDefaultDiscoverableUnitsForCountry(countryCode)
            });

        this.searchField.setGeographicUnits(units);
        this.searchField.setGeographicReleases(geographicRelease);
        this.locationsList.clearLocations();
    },

    onNextClick() {
        var countryCode = this.getSelectedCountry(),
            locations = this.down('selected-locations-list').getLocations();

        this.fireEvent('done', countryCode, locations);
    },

    onSelectLocation(field, locationSeries) {
        this.addLocation(locationSeries);

        this.searchField.focus();
    }
});
